import { useCallback } from "react";

import type { HotelSettingsHotelInfoFormModelOnSetViewModelType } from "../..";
import type { HotelSettingsHotelInfoFormModel } from "../../../../type";

type Props = {
	viewModel: HotelSettingsHotelInfoFormModel["ViewModel"];
	onSetViewModel: HotelSettingsHotelInfoFormModelOnSetViewModelType;
};

export type HotelSettingsHotelInfoFormModelSNSMethodsType = {
	snsMethods: {
		onSetFacebookURL: (value: string) => void;
		onSetInstagramURL: (value: string) => void;
		onSetTwitterURL: (value: string) => void;
		onSetThreadsURL: (value: string) => void;
		onSetLineURL: (value: string) => void;
	};
};

export const useHotelInfoSNS = ({ onSetViewModel }: Props): HotelSettingsHotelInfoFormModelSNSMethodsType => {
	const onSetTwitterURL = useCallback(
		(value: string) => {
			onSetViewModel([
				{
					key: "twitterURL",
					value: {
						isEdited: true,
						value,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	const onSetInstagramURL = useCallback(
		(value: string) => {
			onSetViewModel([
				{
					key: "instagramURL",
					value: {
						isEdited: true,
						value,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	const onSetFacebookURL = useCallback(
		(value: string) => {
			onSetViewModel([
				{
					key: "facebookURL",
					value: {
						isEdited: true,
						value,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	const onSetThreadsURL = useCallback(
		(value: string) => {
			onSetViewModel([
				{
					key: "threadsURL",
					value: {
						isEdited: true,
						value,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	const onSetLineURL = useCallback(
		(value: string) => {
			onSetViewModel([
				{
					key: "lineURL",
					value: {
						isEdited: true,
						value,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		snsMethods: {
			onSetFacebookURL,
			onSetInstagramURL,
			onSetTwitterURL,
			onSetThreadsURL,
			onSetLineURL,
		},
	};
};
